import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(() => ({
  groupLabelWrapper: {
    '&:first-of-type': {
      marginTop: 0,
    },
    '&:last-of-type': {
      marginTop: 0,
    },
  },
}));
